import React from 'react';
import { STORE_LINKS } from '../../config/site';
import { useLang } from '../../i18n/LanguageContext';

// Shows a store badge only when its real URL is set in src/config/site.js.
// With no links configured, nothing is rendered (the product is not publicly available).
export default function StoreButtons({ variant = 'dark' }) {
  const { t } = useLang();
  const stores = [
    { href: STORE_LINKS.appStore, icon: 'fa-brands fa-apple', small: t.common.downloadOn, big: t.common.appStore },
    { href: STORE_LINKS.googlePlay, icon: 'fa-brands fa-google-play', small: t.common.getItOn, big: t.common.googlePlay },
  ].filter((s) => s.href);

  if (stores.length === 0) return null;

  return (
    <div className="store-btns">
      {stores.map((s) => (
        <a key={s.big} className={`store-btn store-btn--${variant}`} href={s.href} target="_blank" rel="noopener noreferrer">
          <i className={s.icon} aria-hidden="true" />
          <span className="store-btn__text">
            <small>{s.small}</small>
            <strong>{s.big}</strong>
          </span>
        </a>
      ))}
    </div>
  );
}
